import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    block: "",
    variant: "outlined",
    size: "large",
    class: "google-button",
    loading: _ctx.working,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signIn()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, { start: "" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("mdi-google", -1)
        ]))]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$tt('auth.google')), 1)
    ]),
    _: 1
  }, 8, ["loading"]))
}